module.exports = __webpack_public_path__ + "img/3.8c4ff05e.jpg";